import styled from 'styled-components';
import { device } from 'styles/breakpoints';

export const Step6Content = styled.div`
  > p:first-child {
    font-family: inherit;
    margin-top: 10px;
    color: #656a66;
    margin-bottom: 24px;
  }
  & ~ div {
    > div:first-child {
      button {
        &:not(:first-child) {
          margin-left: 15px;
        }
      }
    }
  }
`;

export const Step6Subtitle = styled.div`
  position: relative;
  > span {
    position: absolute;
    left: -36px;
    top: 0;
    font-size: 18px;
    line-height: 30px;
  }
  ~ div {
    margin-top: 24px;
  }
`;

export const Step6aWrapper = styled.div`
  min-width: 600px;
  position: relative;
  @media ${device.tablet} {
    min-width: 275px;
  }
`;

export const Step6bWrapper = styled.div`
  min-width: 600px;
  position: relative;
  @media ${device.tablet} {
    min-width: 275px;
  }
`;

export const Step6cWrapper = styled.div`
  min-width: 600px;
  position: relative;
  @media ${device.tablet} {
    min-width: 275px;
  }
`;
